export enum NotesTemplatesFieldsName {
    NAME = 'name',
    LEGAL_FORM = 'legalForm',
    ACCOUNT_BASIS = 'accountBasis',
    NOTES_TYPES = 'notesTypes',
    INFORMATION = 'information',
}
